import React from 'react';

// 동일한 캔버스와 선 굵기로 구성한 운영 앱 심벌.
const symbols = {
  'all-in-one': <><path d="m3 8 9-5 9 5H3Zm1 12h16M6 11v6m6-6v6m6-6v6M3 21h18"/></>,
  'coupon-redeem': <><path d="M4 5h16v5a2 2 0 0 0 0 4v5H4v-5a2 2 0 0 0 0-4Z"/><path d="m8 12 3 3 5-6"/></>,
  'pos-coupon-ops': <><path d="M4 5h16v5a2 2 0 0 0 0 4v5H4v-5a2 2 0 0 0 0-4Z"/><path d="M9 12h6m-3-3v6"/></>,
  'passport-cancel': <><rect x="5" y="3" width="14" height="18" rx="2"/><circle cx="12" cy="9" r="3"/><path d="m10 15 4 3m0-3-4 3M9 9h6"/></>,
  'quest-tag': <><path d="m3 7 6-3 6 3 6-3v15l-6 3-6-3-6 3V7Z"/><path d="M9 4v15m6-12v15"/></>,
  'quest-manual-check': <path d="M8 3H4a1 1 0 0 0-1 1v4m13-5h4a1 1 0 0 1 1 1v4M3 16v4a1 1 0 0 0 1 1h4m8 0h4a1 1 0 0 0 1-1v-4m-13-4 3 3 5-6"/>,
  'quest-status': <><path d="M5 22V3m0 1c5-4 9 4 15 0v11c-6 4-10-4-15 0"/><path d="m10 8 2 2 3-3"/></>,
  'zoolungman': <><ellipse cx="10" cy="6" rx="7" ry="3"/><path d="M3 6v5c0 2 4 3 7 3m-7-3v5c0 2 4 3 7 3"/><ellipse cx="17" cy="15" rx="4" ry="2"/><path d="M13 15v5c0 3 8 3 8 0v-5"/></>,
};
export default function LauncherAppIcon({ id }) {
  return <svg className="launcher-symbol" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{symbols[id]}</svg>;
}
